export const GET_PROJECT_TEMPLATES_REQUEST = 'GET_PROJECT_TEMPLATES_REQUEST';
export const GET_PROJECT_TEMPLATES_SUCCESS = 'GET_PROJECT_TEMPLATES_SUCCESS';
export const GET_PROJECT_TEMPLATES_ERROR = 'GET_PROJECT_TEMPLATES_ERROR';

export const CREATE_PROJECT_TEMPLATE_REQUEST =
  'CREATE_PROJECT_TEMPLATE_REQUEST';
export const CREATE_PROJECT_TEMPLATE_SUCCESS =
  'CREATE_PROJECT_TEMPLATE_SUCCESS';
export const CREATE_PROJECT_TEMPLATE_ERROR = 'CREATE_PROJECT_TEMPLATE_ERROR';

export const DELETE_PROJECT_TEMPLATE_REQUEST =
  'DELETE_PROJECT_TEMPLATE_REQUEST';
export const DELETE_PROJECT_TEMPLATE_SUCCESS =
  'DELETE_PROJECT_TEMPLATE_SUCCESS';
export const DELETE_PROJECT_TEMPLATE_ERROR = 'DELETE_PROJECT_TEMPLATE_ERROR';

export const CLEAR_PROJECT_TEMPLATES_STATE = 'CLEAR_PROJECT_TEMPLATES_STATE';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const CLEAR_ERRORS_PROFILE = 'CLEAR_ERRORS_PROFILE';
export const INIT_REDUCER = 'INIT_REDUCER';

export const UPDATE_PROJECT_TEMPLATE_REQUEST =
  'UPDATE_PROJECT_TEMPLATE_REQUEST';
export const UPDATE_PROJECT_TEMPLATE_SUCCESS =
  'UPDATE_PROJECT_TEMPLATE_SUCCESS';
export const UPDATE_PROJECT_TEMPLATE_ERROR = 'UPDATE_PROJECT_TEMPLATE_ERROR';
export const CREATE_ERRORS = 'CREATE_ERRORS';
